import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import React, { type ReactNode, Fragment } from 'react';
import { graphql, useFragment } from 'react-relay';

import type { PaymentInstallments_charge$key } from './__generated__/PaymentInstallments_charge.graphql.ts';
import PaymentInstallmentRow from './PaymentInstallmentRow.tsx';

type PaymentInstallmentsProps = {
  charge: PaymentInstallments_charge$key;
};
const PaymentInstallments = (props: PaymentInstallmentsProps): ReactNode => {
  const charge = useFragment<PaymentInstallments_charge$key>(
    graphql`
      fragment PaymentInstallments_charge on Charge {
        subscription: paymentSubscription {
          installments: paymentSubscriptionInstallments(first: 12) {
            edges {
              node {
                ...PaymentInstallmentRow_paymentSubscriptionInstallment
              }
            }
          }
        }
        paymentMethods {
          ... on PaymentMethodInstallments {
            method
            subscription {
              installments: paymentSubscriptionInstallments(first: 12) {
                edges {
                  node {
                    ...PaymentInstallmentRow_paymentSubscriptionInstallment
                  }
                }
              }
            }
          }
        }
      }
    `,
    props.charge,
  );

  if (!charge.paymentMethods?.[0]?.subscription?.installments?.edges) {
    return (
      <Stack spacing={1}>
        {charge.subscription?.installments?.edges.map(({ node }, index) => (
          <Fragment key={index}>
            <PaymentInstallmentRow
              key={index}
              paymentSubscriptionInstallment={node}
            />
            <Divider />
          </Fragment>
        ))}
      </Stack>
    );
  }

  return (
    <Stack spacing={1}>
      {charge.paymentMethods[0].subscription.installments.edges.map(
        ({ node }, index) => (
          <Fragment key={index}>
            <PaymentInstallmentRow
              key={index}
              paymentSubscriptionInstallment={node}
            />
            <Divider />
          </Fragment>
        ),
      )}
    </Stack>
  );
};

export default PaymentInstallments;
